var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Logout } from '@mui/icons-material';
import AuthConstants from '../../../constants/Auth.constants';
import LoginModal from '../LoginModal/LoginModal';
import RegisterModal from '../RegisterModal/RegisterModal';
import PopUp from '../../PopUp/PopUp';
import useAuthContext from '../../../utils/hooks/useAuthContext';
import localStorageService from './../../../utils/LocalStorageService';
import UserInfo from '../UserInfo/UserInfo';
import AuthPathConstants from '../../../constants/AuthPath.constants';
import classes from './Authorization.module.css';
var Authorization = function () {
    var _a = useAuthContext(), dataAuth = _a.dataAuth, err = _a.err, isGreeting = _a.isGreeting, isParting = _a.isParting, open = _a.open, isAuth = _a.isAuth, openLogin = _a.openLogin, handleOpen = _a.handleOpen, handleClose = _a.handleClose, unAuthorization = _a.unAuthorization, handlerSubmit = _a.handlerSubmit, handleDataFields = _a.handleDataFields, createUser = _a.createUser, setDBUSer = _a.setDBUSer, handleOpenLogin = _a.handleOpenLogin, handleCloseLogin = _a.handleCloseLogin, logInUser = _a.logInUser, preloader = _a.preloader, notifyAuthFalse = _a.notifyAuthFalse;
    var local = localStorageService.getItem(AuthConstants.USER_KEY_STORAGE);
    useEffect(setDBUSer, [err]);
    useEffect(function () {
        function setNewToken() {
            return __awaiter(this, void 0, void 0, function () {
                var user, info, id, now, lastVisit, tokenTimeDelta, response, status_1, resp;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            user = localStorage.getItem('userInfo');
                            if (!user)
                                return [2 /*return*/];
                            info = JSON.parse(user);
                            id = info.userId;
                            if (!(info && id)) return [3 /*break*/, 4];
                            now = Date.now();
                            lastVisit = Date.parse(String(info.experience));
                            tokenTimeDelta = now - lastVisit;
                            if (!(tokenTimeDelta > AuthConstants.REFRESH_TOKEN_LIFE)) return [3 /*break*/, 4];
                            return [4 /*yield*/, fetch("".concat(AuthPathConstants.BASE).concat(AuthPathConstants.USERS, "/").concat(id).concat(AuthPathConstants.TOKENS), {
                                    headers: {
                                        Authorization: "Bearer ".concat(info.refreshToken),
                                        Accept: 'application/json',
                                        'Content-Type': 'application/json',
                                    },
                                })];
                        case 1:
                            response = _a.sent();
                            status_1 = response;
                            if (!status_1.ok) return [3 /*break*/, 3];
                            return [4 /*yield*/, response.json()];
                        case 2:
                            resp = _a.sent();
                            localStorageService.setItem(AuthConstants.USER_KEY_STORAGE, __assign(__assign({}, info), { experience: new Date(), token: resp.token, refreshToken: resp.refreshToken }));
                            _a.label = 3;
                        case 3:
                            if (!status_1.ok) {
                                notifyAuthFalse();
                            }
                            _a.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        setNewToken();
        var timerID = setInterval(setNewToken, AuthConstants.REFRESH_TOKEN_LIFE);
        return function () { return clearInterval(timerID); };
    }, []);
    return (React.createElement(React.Fragment, null, local && local.isAuth && local.name ? (React.createElement(React.Fragment, null,
        React.createElement(UserInfo, { name: local.name }),
        React.createElement(Logout, { className: classes.logOut, onClick: unAuthorization }))) : (React.createElement(React.Fragment, null,
        React.createElement(LoginModal, { email: dataAuth.email, password: dataAuth.password, error: err, changeFields: handleDataFields, submit: handlerSubmit, logIn: logInUser, open: openLogin, handleOpen: handleOpenLogin, handleClose: handleCloseLogin, preloader: preloader }),
        React.createElement(RegisterModal, { login: dataAuth.login, email: dataAuth.email, password: dataAuth.password, error: err, changeFields: handleDataFields, submit: handlerSubmit, create: createUser, open: open, handleOpen: handleOpen, handleClose: handleClose, preloader: preloader }),
        isGreeting && React.createElement(PopUp, { text: AuthConstants.SUCCESS }),
        isAuth && React.createElement(PopUp, { text: AuthConstants.GREETING }),
        isParting && React.createElement(PopUp, { text: AuthConstants.PARTING })))));
};
export default Authorization;
